import { computed } from 'vue';

import { UserRoleLevel } from '@stuut/api/models';

import { useProfile } from '@/store';

export function useDefaultTaskAssignee() {
  const profileStore = useProfile();

  return computed<string | undefined>(() => {
    const profile = profileStore.profile;
    if (!profile?.id || profile.is_support_user) {
      return undefined;
    }
    switch (profile.userRole) {
      case UserRoleLevel.Admin:
      case UserRoleLevel.Manager:
        return undefined;
      case UserRoleLevel.Member:
      default:
        return profile.id;
    }
  });
}
